import { Link } from "react-router-dom";
import { categoryMeta, type VideoCategory } from "@/mocks/videos";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面不存在 - 高清视频免费观看",
    description:
      "抱歉，你访问的页面不存在。返回高清视频免费观看首页，继续浏览电影、电视剧、综艺等高清视频内容。",
    keywords: "页面不存在,404,高清视频免费观看",
  });

  return (
    <div className="bg-background-100 min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="max-w-xl w-full text-center">
        <p className="font-heading font-extrabold text-7xl md:text-9xl text-primary-500 leading-none">404</p>
        <h1 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mt-4">抱歉，您访问的页面不存在</h1>
        <p className="text-sm md:text-base text-foreground-500 mt-3 leading-relaxed">
          页面可能已被移除、重命名，或链接输入有误。你可以返回首页继续浏览精彩内容，
          或通过下方热门频道快速前往。
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm font-semibold hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-search-line"></i>
            去搜索内容
          </Link>
        </div>

        <div className="mt-10">
          <p className="text-sm text-foreground-500 mb-3">热门频道</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {(Object.keys(categoryMeta) as VideoCategory[]).map((key) => (
              <Link
                key={key}
                to={`/category/${categoryMeta[key].slug}`}
                className="px-4 py-2 rounded-md bg-background-50 border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors"
              >
                {categoryMeta[key].label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}